export function renderWorkersPage(): string {
  return `
    <div class="placeholder">
      <h2>Worker Status</h2>
      <p>Phase 0 smoke test — confirms the Worker can reach DGX over the tunnel.</p>
    </div>
    <div id="worker-status-rows"></div>
  `;
}

interface DgxHealthResponse {
  spark: string;
  upstream_status?: number;
  status?: string;
}

interface DgxCapabilitiesResponse {
  node_id?: string;
  role?: string;
  capabilities?: Array<{ task_type: string }>;
}

export async function hydrateWorkersPage(): Promise<void> {
  const container = document.getElementById('worker-status-rows');
  if (!container) return;

  const sparkId = 'spark-01';

  const apiHealthRow = row('Edge API /api/health', '…');
  const dgxHealthRow = row(`DGX ${sparkId} /health (via Worker)`, '…');
  const dgxCapsRow = row(`DGX ${sparkId} /capabilities (via Worker)`, '…');
  container.append(apiHealthRow.el, dgxHealthRow.el, dgxCapsRow.el);

  fetch('/api/health')
    .then((r) => r.json())
    .then((body: { status?: string }) =>
      apiHealthRow.set(body.status === 'ok' ? 'ok' : 'unexpected payload', body.status === 'ok'),
    )
    .catch((e: unknown) => apiHealthRow.set(`error: ${describe(e)}`, false));

  fetch(`/api/dgx/health?spark=${sparkId}`)
    .then((r) => r.json())
    .then((body: DgxHealthResponse) => {
      const ok = body.upstream_status === 200 && body.status === 'ok';
      dgxHealthRow.set(ok ? 'ok' : `upstream ${body.upstream_status ?? '?'}`, ok);
    })
    .catch((e: unknown) => dgxHealthRow.set(`error: ${describe(e)}`, false));

  fetch(`/api/dgx/capabilities?spark=${sparkId}`)
    .then((r) => r.json())
    .then((body: DgxCapabilitiesResponse) => {
      const taskTypes = body.capabilities?.map((c) => c.task_type).join(', ') ?? '—';
      dgxCapsRow.set(`${body.role ?? '?'}: ${taskTypes}`, true);
    })
    .catch((e: unknown) => dgxCapsRow.set(`error: ${describe(e)}`, false));
}

function row(label: string, initial: string): { el: HTMLDivElement; set: (v: string, ok: boolean) => void } {
  const el = document.createElement('div');
  el.className = 'status-row';
  el.innerHTML = `<span class="label">${label}</span><span class="value">${initial}</span>`;
  return {
    el,
    set: (v, ok) => {
      const value = el.querySelector('.value');
      if (!value) return;
      value.textContent = v;
      value.classList.toggle('ok', ok);
      value.classList.toggle('err', !ok);
    },
  };
}

function describe(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}
